(function () {
	'use strict';
	angular
		.module('app.core')
		.directive('pipelineStepRerun', pipelineStepRerun);

	function pipelineStepRerun($uibModal) {
		return {
			restrict: 'E',
			template: '<a class="data-pipeline-rerun" title="Clear and re-run" href="#" ng-click="$event.preventDefault();vm.openModal()"><i class="fa fa-repeat"></i></a>',
			scope: {
				factoryndx: '@',
				factory: '@',
				type: '@',
				jobid: '@',
				isvalidationfailure: '@',
				healthcheckfailures: '@'
			},
			controller: pipelineStepRerunCtrl,
			controllerAs: 'vm'
		};
	}

	pipelineStepRerunCtrl.$inject = ['$rootScope', '$scope', '$uibModal', 'dataPipelineService'];
	function pipelineStepRerunCtrl($rootScope, $scope, $uibModal, dataPipelineService){
		var vm = this;
		vm.openModal = openModal;
		vm.factoryNdx = $scope.factoryndx;
		vm.factory = $scope.factory;
		vm.type = $scope.type;
		vm.jobId = $scope.jobid;		
		vm.isValidationFailure = $scope.isvalidationfailure === 'true';
		vm.healthCheckFailures = $scope.healthcheckfailures === 'undefined' ? false : $scope.healthcheckfailures.split(', ');
	
		function openModal() {
			var modal = $uibModal.open({
				ariaLabelledBy: 'modal-title',
				ariaDescribedBy: 'modal-body',
				templateUrl: '/application/f/setup/rerun-data-job.html',
				controller: function($rootScope) {
					var vmModal = this;
					vmModal.closeModal = closeModal;
					vmModal.rerun = rerun;
					vmModal.isValidationFailure = vm.isValidationFailure;
					vmModal.factory = vm.factory;
					vmModal.typeDisplay = vm.type === 'Procurement' ? 'Analytics' : vm.type;
					vmModal.healthCheckFailures = vm.healthCheckFailures;
					
					function closeModal() {
						modal.close('cancel');
					}
			
					function rerun() {
						var tablesToClear = [];
						if (!vmModal.healthCheckFailures) {
							if (vmModal.inventorySelected) {
								tablesToClear.push('Inventory');
							}
							if (vmModal.requirementsSelected) {
								tablesToClear.push('Requirement');
							}
							if (vmModal.purchaseordersSelected) {
								tablesToClear.push('SupplierPurchaseOrder');
							}
							if (vmModal.receiptsSelected) {
								tablesToClear.push('SupplierPurchaseOrderReceipt');
							}
						}
						dataPipelineService.rerun(vm.factoryNdx, vm.jobId, tablesToClear, vmModal.approver)
							.then(function(error) {
								if (error === '') {
									$rootScope.$emit('toast', {
										'message': 'Job re-run requested',
										'success': true
									});
								} else {
									$rootScope.$emit('toast', {
										'message': error,
										'success': false,
										'time': 10000
									});
								}
								modal.close('continue');
							});
					}
				},
				controllerAs: 'vm'
			});
		}
	}
})();
